import React, { Component } from 'react'
import { Row, Col, Button, Label, Alert, Nav, NavItem, NavLink, TabContent, TabPane, Badge } from 'reactstrap'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import withApolloClient from '../../withApolloClient'
import toTitleCase from "../../Functions/toTitleCase"
import AddPeopleModal from '../IncidentModals/AddPeopleModal'
import PersonInfo from './PersonInfo'
import AddVehicleModal from '../IncidentModals/AddVehicleModal'
import AddPartyEntityModal from '../IncidentModals/AddPartyEntityModal'
import VehicleInfo from './VehicleInfo'
import DatetimeRenderer from '../../Material/DatetimeRenderer'
import HistoryTab from '../HistoryTab/HistoryTab'
import ConfirmationPopup from '../../Material/ConfirmationPopup'
import DocumentsTab from '../DocumentsTab/DocumentsTab'

const AllIncidentParties = gql`query AllIncidentParties($incidentId: ID!, $isArchived: Boolean) {
    allIncidentParties(incidentId:$incidentId, isArchived:$isArchived) {
        edges {
            node {
                id
                pk
                dateAdded
                partyType
                partyName
                isDefault
                history {
                    date
                    user
                    comment
                }
                incident{
                    id
                    rental {
                        id
                    }
                }
                vehicles {
                    edges {
                        node {
                            id
                            dateAdded
                            vin
                            make
                            model
                            year
                            plateNumber
                            damageDescription
                            insuranceCompany
                            policyNumber
                            history {
                                date
                                user
                                comment
                            }
                        }
                    }
                }
                incidentpartypeopleSet(isArchived:false){
                    edges {
                        node {
                            id
                            dateAdded
                            name
                            phoneNumber
                            email
                            address
                            role
                            driverLicense
                            injuries
                            statement
                            isBusinessEntity
                            respresentative {
                                id
                                name
                            }
                            history{
                                date
                                user
                                comment
                            }
                        }
                    }
                }
            }
        }
    }
}`

const ArchiveIncidentParty = gql`
  mutation ArchiveIncidentPartyMutation($input: ArchiveIncidentPartyMutationInput!) {
    archiveIncidentParty(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`
const UnarchiveIncidentParty = gql`
    mutation UnarchiveIncidentPartyMutation($input: UnarchiveIncidentPartyMutationInput!) {
        unarchiveIncidentParty(input: $input) {
            ok
            errors {
                field
                messages
            }
        }
    }
`
const UpdateIncidentPartyPeople = gql`
    mutation updateIncidentPartyPeopleMutation($input: UpdateIncidentPartyPeopleMutationInput!){
    updateIncidentPartyPeople(input:$input){
        ok
        errors{
            field
            messages
        }
    }
} `
const personTableHeader = [
    { key: 'date_added', label: 'Date Added' },
    { key: 'party_name', label: 'Party Name' },
    { key: 'name_role', label: 'Name (Role)' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'action', label: 'Action' },
]

const DRIVER_ROLES = ["VEHICLE_DRIVER", "UNAUTHORIZED_DRIVER", "EMPLOYEE", "VENDOR"]
class PartiesTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openVehicleInfoId: null,
            openPersonInfoId: null,
            witnessTab: 'info',
            nonMotoristTab: 'info',
            unauthorizedDriverTab: 'info',
            error: '',
            openModal: '',
            loading: false,
            documentsByParty: {},
            documentsLoading: {},
        }
    }

    handlePartyArchive = (id) => {
        this.setState({ loading: true, error: '' })
        const mutation = this.props.isArchived ? UnarchiveIncidentParty : ArchiveIncidentParty
        this.props.apolloClient.mutate({
            mutation,
            variables: { input: { partyId: id } },
        }).then((result) => {
            const dataKey = this.props.isArchived ? 'unarchiveIncidentParty' : 'archiveIncidentParty'
            const res = result.data && result.data[dataKey]
            if (res && res.ok) {
                this.props.refetchQuery && this.props.refetchQuery()
                this.setState({ openModal: "" })
            } else if (res?.errors) {
                this.setState({ loading: false, error: res.errors[0].messages[0] })
            }
        }).catch((error) => {
            let errorMessage = "An error has occured" + (error.message ? (": " + error.message) : ".")
            this.setState({ error: errorMessage, loading: false, })
        }).finally(() => {
            this.setState({ loading: false })
        })
    }

    handlePeopleArchive = (id) => {
        this.setState({ loading: true, error: '' })
        const mutation = UpdateIncidentPartyPeople
        this.props.apolloClient.mutate({
            mutation,
            variables: { input: { partyPeopleId: id, isArchived: true } },
        }).then((result) => {
            let res = result.data && result.data["updateIncidentPartyPeople"]
            if (res && res.ok) {
                this.props.refetchQuery && this.props.refetchQuery()
                this.setState({ openModal: "" })
            } else if (res?.errors) {
                this.setState({ loading: false, error: res.errors[0].messages[0] })
            }
        }).catch((error) => {
            let errorMessage = "An error has occured" + (error.message ? (": " + error.message) : ".")
            this.setState({ error: errorMessage, loading: false, })
        }).finally(() => {
            this.setState({ loading: false })
        })
    }

    renderArchivePartyModal = (partyType, partyId) => {
        const { isArchived } = this.props
        return (
            <ConfirmationPopup
                open={true}
                message={`Are you sure you want to ${isArchived ? "un-archive" : "archive"} this ${toTitleCase(partyType)} party?`}
                confirmAction={() => this.handlePartyArchive(partyId)}
                action={isArchived ? "Un-Archive" : "Yes"}
                color={isArchived ? "success" : "danger"}
                loading={this.state.loading}
                handleClose={() => this.setState({ openModal: "" })}
                error={this.state.error ? this.state.error : ""}
            />
        )
    }

    renderArchivePartyPeopleModal = (personRole, personId) => {
        return (
            <ConfirmationPopup
                open={true}
                message={`Are you sure you want to archive this ${toTitleCase(personRole)}?`}
                confirmAction={() => this.handlePeopleArchive(personId)}
                action={"Yes"}
                color={"danger"}
                loading={this.state.loading}
                handleClose={() => this.setState({ openModal: "" })}
                error={this.state.error ? this.state.error : ""}
            />
        )
    }

    render() {
        const { allIncidentParties, loading } = this.props
        let vehicleParties = allIncidentParties?.edges?.map(edge => edge.node).filter(party => party.partyType === 'VEHICLE')
        let witnessParties = allIncidentParties?.edges?.map(edge => edge.node).filter(party => party.partyType === 'WITNESS')
        let nonMotoristParties = allIncidentParties?.edges?.map(edge => edge.node).filter(party => party.partyType === 'NON_MOTORIST')
        return (
            <>
                {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                <Row>
                    <Col xs="12" className="pb-2">
                        <h4>
                            <i className="fa fa-car" aria-hidden="true" />&nbsp;&nbsp;VEHICLE
                            {!this.props.isArchived && <Button color="primary" size="sm" className="float-right" onClick={() => this.setState({ openModal: "AddVehicleModal" })}>Add Vehicle</Button>}
                            {this.state.openModal === "AddVehicleModal" &&
                                <AddVehicleModal
                                    isOpen={true}
                                    toggle={() => this.setState({ openModal: "" })}
                                    incidentId={this.props?.id}
                                    refetchQuery={this.props.refetchQuery}
                                />
                            }
                        </h4>
                        {loading ? <Skeleton count={5} height={30} /> : vehicleParties?.length > 0 && (
                            <div className='info-container mb-4'>
                                <Row>
                                    <Col xs={12}>
                                        <Row>
                                            <Col><Label>Date Added</Label></Col>
                                            <Col><Label>Party Name</Label></Col>
                                            <Col><Label>Party Type</Label></Col>
                                            <Col><Label>Driver Name</Label></Col>
                                            <Col><Label>Passenger Name</Label></Col>
                                            <Col xs={1}><Label>Action</Label></Col>
                                        </Row>
                                        <hr />
                                        {vehicleParties.map(party => {
                                            const partyOpen = this.state.openVehicleInfoId === party.id
                                            const tabKey = `vehicleTab_${party.id}`
                                            const activeTab = this.state[tabKey] || 'vehicle'
                                            const historyTabKey = this.state[`historyTab_${party.id}`] || 'vehicleHistory'
                                            const setHistoryTab = tab => this.setState({ [`historyTab_${party.id}`]: tab })
                                            const setTab = tab => {
                                                this.setState({ [tabKey]: tab })
                                            }
                                            const driver = party.incidentpartypeopleSet?.edges?.find(person => DRIVER_ROLES.includes(person.node.role))
                                            const driverDisplay = driver ? `${driver.node.name || '--'} (${toTitleCase(driver.node.role)})` : "--"
                                            const passenger = party.incidentpartypeopleSet?.edges?.find(person => person.node.role === 'VEHICLE_PASSENGER')
                                            return (
                                                <React.Fragment key={party.id}>
                                                    <Row>
                                                        <Col><p className='mb-0'>{<DatetimeRenderer datetime={party.dateAdded} /> || "--"}</p></Col>
                                                        <Col><p className='mb-0'>{party.partyName || "--"}&nbsp;{party.isDefault && <Badge color={"primary"}>DEFAULT PARTY</Badge>}</p></Col>
                                                        <Col><p className='mb-0'>{party.partyType || "--"}</p></Col>
                                                        <Col><p className='mb-0'>{driverDisplay}</p></Col>
                                                        <Col><p className='mb-0'>{passenger?.node?.name || "--"}</p></Col>
                                                        <Col xs={1} className='d-flex align-items-center'>
                                                            <p className='mb-0' style={{ cursor: 'pointer' }} onClick={() => this.setState({ openVehicleInfoId: partyOpen ? null : party.id })}>
                                                                {partyOpen ? <i className="fa fa-chevron-up" /> : <i className="fa fa-chevron-down" />}&nbsp;&nbsp;
                                                            </p>
                                                            {!party.isDefault && <p className='mb-0' style={{ borderLeft: "1px solid #ccc" }}>
                                                                &nbsp; <i className={`fa ${this.props.isArchived ? 'fa-undo' : 'fa-archive'} cursor-pointer`}
                                                                    title={this.props.isArchived ? 'Un-Archive Party' : 'Archive Party'}
                                                                    style={{ color: this.props.isArchived ? '#68bb59' : '#FF8358' }}
                                                                    onClick={() => this.setState({ openModal: "archiveVehicleParty" + party.id })}></i>
                                                                {this.state.openModal === "archiveVehicleParty" + party.id && this.renderArchivePartyModal(party.partyType, party.id)}
                                                            </p>}
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    {partyOpen && (
                                                        <div className="info-container mb-3" style={{ background: "white" }}>
                                                            <Nav tabs className="mb-3">
                                                                <NavItem>
                                                                    <NavLink active={activeTab === 'vehicle'} onClick={() => setTab('vehicle')}>Vehicle Info</NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink active={activeTab === 'driver'} onClick={() => setTab('driver')}>Driver Info</NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink active={activeTab === 'passenger'} onClick={() => setTab('passenger')}>Passenger Info</NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink active={activeTab === 'documents'} onClick={() => setTab('documents')}>Documents</NavLink>
                                                                </NavItem>
                                                                <NavItem>
                                                                    <NavLink active={activeTab === 'history'} onClick={() => setTab('history')}>History</NavLink>
                                                                </NavItem>
                                                            </Nav>
                                                            <TabContent activeTab={activeTab}>
                                                                <TabPane tabId="vehicle">
                                                                    {party?.vehicles?.edges.map((veh, vIdx) => (
                                                                        <div key={veh.node.id} className="mb-3">
                                                                            <VehicleInfo vehicle={veh.node} refetchQuery={this.props.refetchQuery} isDefault={party.isDefault} />
                                                                        </div>
                                                                    ))}
                                                                    {party.vehicles.edges.length === 0 && <><Button color="primary" size="sm" onClick={() => this.setState({ openModal: "AddVehicleEntityModal" })}>Add Vehicle</Button>&nbsp;&nbsp;
                                                                        {this.state.openModal === "AddVehicleEntityModal" &&
                                                                            <AddPartyEntityModal
                                                                                isOpen={true}
                                                                                toggle={() => this.setState({ openModal: "" })}
                                                                                entity="VEHICLE"
                                                                                partyId={party?.id}
                                                                                refetchQuery={this.props.refetchQuery}
                                                                            />
                                                                        }
                                                                    </>}
                                                                </TabPane>
                                                                <TabPane tabId="driver">
                                                                    {party.incidentpartypeopleSet?.edges?.filter(person => DRIVER_ROLES.includes(person.node.role)).map((person, idx) => (
                                                                        <>
                                                                            <div key={person.node.id} className="mb-4">
                                                                                <PersonInfo person={person.node} refetchQuery={this.props.refetchQuery} isDefault={party.isDefault} />
                                                                                <Button color="danger" size="sm" className="float-right" onClick={() => this.setState({ openModal: "ArchiveDefaultVehicleDriverModal" + person.node.id })}>Archive {toTitleCase(person.node.role)}</Button>
                                                                                {this.state.openModal === "ArchiveDefaultVehicleDriverModal" + person.node.id && this.renderArchivePartyPeopleModal(person.node.role, person.node.id)}
                                                                                <br /><br />
                                                                                <hr />
                                                                            </div>
                                                                        </>
                                                                    ))}
                                                                    {party.isDefault ? <>
                                                                        <Button color="primary" size="sm" onClick={() => this.setState({ openModal: "AddDefaultVehicleDriverModal" + party.id })}>Add Driver</Button>
                                                                        {this.state.openModal === "AddDefaultVehicleDriverModal" + party.id && <AddPeopleModal isOpen={true} toggle={() => this.setState({ openModal: "" })} partyType="VEHICLE" roles={DRIVER_ROLES} partyId={party.id} refetchQuery={this.props.refetchQuery} />}
                                                                    </>
                                                                        : party.incidentpartypeopleSet.edges.filter(person => ["VEHICLE_DRIVER", 'UNAUTHORIZED_DRIVER'].includes(person.node.role)).length === 0 && <>
                                                                            {this.state.openModal === "AddVehicleDriverModal" + party.id && <AddPeopleModal isOpen={true} toggle={() => this.setState({ openModal: "" })} partyType="VEHICLE" role="VEHICLE_DRIVER" partyId={party.id} refetchQuery={this.props.refetchQuery} />}
                                                                            <Button color="primary" size="sm" onClick={() => this.setState({ openModal: "AddVehicleDriverModal" + party.id })}>Add Driver</Button>&nbsp;&nbsp;
                                                                        </>}
                                                                </TabPane>
                                                                <TabPane tabId="passenger">
                                                                    {party.incidentpartypeopleSet?.edges?.filter(person => person.node.role === "VEHICLE_PASSENGER").map((person, idx) => (
                                                                        <div key={person.node.id} className="mb-3">
                                                                            <PersonInfo person={person.node} refetchQuery={this.props.refetchQuery} isDefault={party.isDefault} />
                                                                        </div>
                                                                    ))}
                                                                    {party.incidentpartypeopleSet.edges.filter(person => person.node.role === 'VEHICLE_PASSENGER').length === 0 && <>
                                                                        <Button color="primary" size="sm" onClick={() => this.setState({ openModal: "AddPassengerEntityModal" })}>Add Passenger</Button>
                                                                        {this.state.openModal === "AddPassengerEntityModal" &&
                                                                            <AddPartyEntityModal
                                                                                isOpen={true}
                                                                                toggle={() => this.setState({ openModal: "" })}
                                                                                entity="VEHICLE_PASSENGER"
                                                                                partyId={party?.id}
                                                                                refetchQuery={this.props.refetchQuery}
                                                                            />
                                                                        }</>}
                                                                </TabPane>
                                                                <TabPane tabId="documents">
                                                                    <DocumentsTab
                                                                        id={this.props.id}
                                                                        slug={"PARTY_" + party.id}
                                                                        refetchQuery={this.props.refetchQuery}
                                                                        viewType={"party"}
                                                                        category={"PARTY"}
                                                                    />
                                                                </TabPane>
                                                                <TabPane tabId="history">
                                                                    <div className='info-container mt-0'>
                                                                        <Nav tabs className="mb-3">
                                                                            <NavItem>
                                                                                <NavLink active={historyTabKey === 'vehicleHistory'} onClick={() => setHistoryTab('vehicleHistory')}>Vehicle History</NavLink>
                                                                            </NavItem>
                                                                            <NavItem>
                                                                                <NavLink active={historyTabKey === 'passengerHistory'} onClick={() => setHistoryTab('passengerHistory')}>Passenger History</NavLink>
                                                                            </NavItem>
                                                                            <NavItem>
                                                                                <NavLink active={historyTabKey === 'driverHistory'} onClick={() => setHistoryTab('driverHistory')}>Driver History</NavLink>
                                                                            </NavItem>
                                                                        </Nav>
                                                                        <TabContent activeTab={historyTabKey}>
                                                                            <TabPane tabId="vehicleHistory">
                                                                                <HistoryTab history={party?.vehicles?.edges?.map(edge => edge.node).flatMap(veh => veh.history || []).sort((a, b) => new Date(b.date) - new Date(a.date))} />
                                                                            </TabPane>
                                                                            <TabPane tabId="passengerHistory">
                                                                                <HistoryTab history={party?.incidentpartypeopleSet?.edges?.filter(edge => edge.node.role === 'VEHICLE_PASSENGER').map(edge => edge.node).flatMap(person => person.history || []).sort((a, b) => new Date(b.date) - new Date(a.date))} />
                                                                            </TabPane>
                                                                            <TabPane tabId="driverHistory">
                                                                                <HistoryTab history={party?.incidentpartypeopleSet?.edges?.filter(edge => ['VEHICLE_DRIVER', 'UNAUTHORIZED_DRIVER'].includes(edge.node.role)).map(edge => edge.node).flatMap(person => person.history || []).sort((a, b) => new Date(b.date) - new Date(a.date))} />
                                                                            </TabPane>
                                                                        </TabContent>
                                                                    </div>
                                                                </TabPane>
                                                            </TabContent>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )
                                        })}
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Col>
                </Row>
                {/* WITNESS SECTION */}
                <Row className='mt-4'>
                    <Col xs="12" className="pb-2">
                        <h4>
                            <i className="fa fa-users" aria-hidden="true" />&nbsp;&nbsp;WITNESS
                            {!this.props.isArchived && <Button color="primary" size="sm" className="float-right" onClick={() => this.setState({ openModal: "AddWitnessModal" })}>Add Witness</Button>}
                            {this.state.openModal === "AddWitnessModal" &&
                                <AddPeopleModal
                                    isOpen={true}
                                    toggle={() => this.setState({ openModal: "" })}
                                    partyType="WITNESS"
                                    role="WITNESS"
                                    incidentId={this.props?.id}
                                    refetchQuery={this.props.refetchQuery}
                                />
                            }
                        </h4>
                        {loading ? <Skeleton count={5} height={30} /> :
                            witnessParties?.length > 0 && (
                                <div className='info-container mb-4'>
                                    <Row>
                                        {personTableHeader.map(col => (
                                            <Col key={col.key} xs={col.key === 'action' ? 1 : ""}><Label>{col.label}</Label></Col>
                                        ))}
                                    </Row>
                                    <hr />
                                    {witnessParties.map(party => {
                                        const partyOpen = this.state.openPersonInfoId === party.id
                                        const partyTabKey = `witnessTab_${party.id}`
                                        const activeTab = this.state[partyTabKey] || 'info'
                                        const historyTabKey = this.state[`witnessHistoryTab_${party.id}`] || 'peopleHistory'
                                        const setHistoryTab = tab => this.setState({ [`witnessHistoryTab_${party.id}`]: tab })
                                        const setTab = tab => {
                                            this.setState({ [partyTabKey]: tab })
                                        }
                                        const driver = party.incidentpartypeopleSet?.edges?.find(person => person.node.role === 'WITNESS')
                                        const driverDisplay = driver ? `${driver.node.name || '--'} (${toTitleCase(driver.node.role)})` : "--"
                                        return (
                                            <div key={party.id} className="mb-4">
                                                <Row>
                                                    <Col><p className='mb-0'>{<DatetimeRenderer datetime={party.dateAdded} /> || '--'}</p></Col>
                                                    <Col><p className='mb-0'>{party.partyName || '--'}</p></Col>
                                                    <Col><p className='mb-0'>{driverDisplay || '--'}</p></Col>
                                                    <Col><p className='mb-0'>{driver?.node?.email || "--"}</p></Col>
                                                    <Col><p className='mb-0'>{driver?.node?.phoneNumber || "--"}</p></Col>
                                                    <Col xs={1} className='d-flex align-items-center'>
                                                        <p className='mb-0' style={{ cursor: 'pointer', borderRight: "1px solid #ccc" }} onClick={() => this.setState({ openPersonInfoId: partyOpen ? null : party.id })}>
                                                            {partyOpen ? <i className="fa fa-chevron-up" /> : <i className="fa fa-chevron-down" />}&nbsp;&nbsp;
                                                        </p>
                                                        <p className='mb-0'>
                                                            &nbsp; <i className={`fa ${this.props.isArchived ? 'fa-undo' : 'fa-archive'} cursor-pointer`}
                                                                style={{ color: this.props.isArchived ? '#68bb59' : '#FF8358' }}
                                                                title={this.props.isArchived ? 'Un-Archive Party' : 'Archive Party'}
                                                                onClick={() => this.setState({ openModal: "archiveWitnessParty" + party.id })}></i>
                                                            {this.state.openModal === "archiveWitnessParty" + party.id && this.renderArchivePartyModal(party.partyType, party.id)}
                                                        </p>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {partyOpen && (
                                                    <div className="info-container mb-3" style={{ background: "white" }}>
                                                        <Nav tabs className="mb-3">
                                                            <NavItem>
                                                                <NavLink active={activeTab === 'info'} onClick={() => setTab('info')}>Party Info</NavLink>
                                                            </NavItem>
                                                            <NavItem>
                                                                <NavLink active={activeTab === 'documents'} onClick={() => setTab('documents')}>Documents</NavLink>
                                                            </NavItem>
                                                            <NavItem>
                                                                <NavLink active={activeTab === 'history'} onClick={() => setTab('history')}>History</NavLink>
                                                            </NavItem>
                                                        </Nav>
                                                        <TabContent activeTab={activeTab}>
                                                            <TabPane tabId="info">
                                                                {party.incidentpartypeopleSet?.edges?.map((person, idx) => (
                                                                    <div key={person.node.id} className="mb-3">
                                                                        <PersonInfo person={person.node} refetchQuery={this.props.refetchQuery} isDefault={party.isDefault} />
                                                                    </div>
                                                                ))}
                                                            </TabPane>
                                                            <TabPane tabId="documents">
                                                                <DocumentsTab
                                                                    id={this.props.id}
                                                                    slug={"PARTY_" + party.id}
                                                                    refetchQuery={this.props.refetchQuery}
                                                                    viewType={"party"}
                                                                    category={"PARTY"}
                                                                />
                                                            </TabPane>
                                                            <TabPane tabId="history">
                                                                <div className='info-container mt-0'>
                                                                    <Nav tabs className="mb-3">
                                                                        <NavItem>
                                                                            <NavLink active={historyTabKey === 'peopleHistory'} onClick={() => setHistoryTab('peopleHistory')}>People History</NavLink>
                                                                        </NavItem>
                                                                    </Nav>
                                                                    <TabContent activeTab={historyTabKey}>
                                                                        <TabPane tabId="peopleHistory">
                                                                            <HistoryTab history={party.incidentpartypeopleSet?.edges?.flatMap(edge => edge.node.history || []).sort((a, b) => new Date(b.date) - new Date(a.date))} />
                                                                        </TabPane>
                                                                    </TabContent>
                                                                </div>
                                                            </TabPane>
                                                        </TabContent>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                    </Col>
                </Row>
                {/* NON MOTORIST SECTION */}
                <Row className='mt-4'>
                    <Col xs="12" className="pb-2">
                        <h4>
                            <i className="fa fa-male" aria-hidden="true" />&nbsp;&nbsp;NON MOTORIST
                            {!this.props.isArchived && <Button color="primary" size="sm" className="float-right" onClick={() => this.setState({ openModal: "AddNonMotoristModal" })}>Add Non Motorist</Button>}
                            {this.state.openModal === "AddNonMotoristModal" &&
                                <AddPeopleModal
                                    isOpen={true}
                                    toggle={() => this.setState({ openModal: "" })}
                                    partyType="NON_MOTORIST"
                                    role="NON_MOTORIST"
                                    incidentId={this.props?.id}
                                    refetchQuery={this.props.refetchQuery}
                                />
                            }
                        </h4>
                        {loading ? <Skeleton count={5} height={30} /> : nonMotoristParties?.length > 0 && (
                            <div className='info-container mb-4'>
                                <Row>
                                    {personTableHeader.map(col => (
                                        <Col key={col.key} xs={col.key === 'action' ? 1 : ""}><Label>{col.label}</Label></Col>
                                    ))}
                                </Row>
                                <hr />
                                {nonMotoristParties.map(party => {
                                    const partyOpen = this.state.openPersonInfoId === party.id
                                    const partyTabKey = `nonMotoristTab_${party.id}`
                                    const activeTab = this.state[partyTabKey] || 'info'
                                    const historyTabKey = this.state[`nonMotoristHistoryTab_${party.id}`] || 'peopleHistory'
                                    const setHistoryTab = tab => this.setState({ [`nonMotoristHistoryTab_${party.id}`]: tab })
                                    const setTab = tab => {
                                        this.setState({ [partyTabKey]: tab })
                                    }
                                    const driver = party.incidentpartypeopleSet?.edges?.find(person => person.node.role === 'NON_MOTORIST')
                                    const driverDisplay = driver ? `${driver.node.name || '--'} (${toTitleCase(driver.node.role)})` : "--"
                                    return (
                                        <div key={party.id} className="mb-4">
                                            <Row>
                                                <Col><p className='mb-0'>{<DatetimeRenderer datetime={party.dateAdded} /> || '--'}</p></Col>
                                                <Col><p className='mb-0'>{party.partyName || '--'}</p></Col>
                                                <Col><p className='mb-0'>{driverDisplay || '--'}</p></Col>
                                                <Col><p className='mb-0'>{driver?.node?.email || "--"}</p></Col>
                                                <Col><p className='mb-0'>{driver?.node?.phoneNumber || "--"}</p></Col>
                                                <Col xs={1} className='d-flex align-items-center'>
                                                    <p className='mb-0' style={{ cursor: 'pointer', borderRight: '1px solid #ccc' }} onClick={() => this.setState({ openPersonInfoId: partyOpen ? null : party.id })}>
                                                        {partyOpen ? <i className="fa fa-chevron-up" /> : <i className="fa fa-chevron-down" />}&nbsp;&nbsp;
                                                    </p>
                                                    <p className='mb-0'>
                                                        &nbsp; <i className={`fa ${this.props.isArchived ? 'fa-undo' : 'fa-archive'} cursor-pointer`}
                                                            style={{ color: this.props.isArchived ? '#68bb59' : '#FF8358' }}
                                                            title={this.props.isArchived ? 'Un-Archive Party' : 'Archive Party'}
                                                            onClick={() => this.setState({ openModal: "archiveNonMotoristParty" + party.id })}></i>
                                                        {this.state.openModal === "archiveNonMotoristParty" + party.id && this.renderArchivePartyModal(party.partyType, party.id)}
                                                    </p>
                                                </Col>
                                            </Row>
                                            <hr />
                                            {partyOpen && (
                                                <div className="info-container mb-3" style={{ background: "white" }}>
                                                    <Nav tabs className="mb-3">
                                                        <NavItem>
                                                            <NavLink active={activeTab === 'info'} onClick={() => setTab('info')}>Party Info</NavLink>
                                                        </NavItem>
                                                        <NavItem>
                                                            <NavLink active={activeTab === 'documents'} onClick={() => setTab('documents')}>Documents</NavLink>
                                                        </NavItem>
                                                        <NavItem>
                                                            <NavLink active={activeTab === 'history'} onClick={() => setTab('history')}>History</NavLink>
                                                        </NavItem>
                                                    </Nav>
                                                    <TabContent activeTab={activeTab}>
                                                        <TabPane tabId="info">
                                                            {party.incidentpartypeopleSet?.edges?.map((person, idx) => (
                                                                <div key={person.node.id} className="mb-3">
                                                                    <PersonInfo person={person.node} refetchQuery={this.props.refetchQuery} isDefault={party.isDefault} />
                                                                </div>
                                                            ))}
                                                        </TabPane>
                                                        <TabPane tabId="documents">
                                                            <DocumentsTab
                                                                id={this.props.id}
                                                                slug={"PARTY_" + party.id}
                                                                refetchQuery={this.props.refetchQuery}
                                                                viewType={"party"}
                                                                category={"PARTY"}
                                                            />
                                                        </TabPane>
                                                        <TabPane tabId="history">
                                                            <div className='info-container mt-0'>
                                                                <Nav tabs className="mb-3">
                                                                    <NavItem>
                                                                        <NavLink active={historyTabKey === 'peopleHistory'} onClick={() => setHistoryTab('peopleHistory')}>People History</NavLink>
                                                                    </NavItem>
                                                                </Nav>
                                                                <TabContent activeTab={historyTabKey}>
                                                                    <TabPane tabId="peopleHistory">
                                                                        <HistoryTab history={party.incidentpartypeopleSet?.edges?.flatMap(edge => edge.node.history || []).sort((a, b) => new Date(b.date) - new Date(a.date))} />
                                                                    </TabPane>
                                                                </TabContent>
                                                            </div>
                                                        </TabPane>
                                                    </TabContent>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </Col>
                </Row>
            </>
        )
    }
}

export default graphql(AllIncidentParties, {
    options: ({ id, isArchived }) => ({
        variables: {
            incidentId: id,
            isArchived: isArchived
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { allIncidentParties, loading, refetch, variables, } }) => ({
        allIncidentParties,
        loading,
        variables,
        refetchQuery: () => {
            return refetch({
                query: AllIncidentParties,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { allIncidentParties: fetchMoreResult.allIncidentParties }
                },
            })
        },
    }),
})(withApolloClient(PartiesTab))
